module.exports = __webpack_public_path__ + "static/media/5f6110f228564-modified.ab48b15b.jpg";